import { FormControlLabel, Switch } from '@mui/material'
import { ChangeEvent, useEffect } from 'react'
import { getAppName } from 'shared/helpers/getAppName'
import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'

export const IsUrlExtendedSwitch = () => {
  const updateMenuConfig = useConfigStore().updateMenuConfig
  const config = useConfigStore().config?.menuConfig
  const isCC = useGlobalStore().isCCSelected

  useEffect(() => {
    if (typeof config?.[getAppName(isCC)]?.isUrlExtended === 'undefined') {
      updateMenuConfig({ isUrlExtended: true })
    }
  }, [config?.[getAppName(isCC)]?.isUrlExtended])

  const handleIsUrlExtended = (value: ChangeEvent<HTMLInputElement>) => {
    updateMenuConfig({ isUrlExtended: value.target.checked })
  }

  return (
    <FormControlLabel
      control={
        <Switch
          checked={config?.[getAppName(isCC)]?.isUrlExtended || false}
          name='isUrlExtended'
          onChange={handleIsUrlExtended}
        />
      }
      label='Include room and table to url'
    />
  )
}
